import LegalLayout from './LegalLayout';

const CGV = () => {
  return (
    <LegalLayout
      title="Conditions Générales de Vente"
      description="Conditions Générales de Vente d'AlloRéparations Montpellier — réparation, garantie 6 mois, vente d'iPhone d'occasion, rachat de téléphone."
      lastUpdated="27 avril 2026"
    >
      <section data-testid="section-objet">
        <h2>1. Objet et champ d'application</h2>
        <p>
          Les présentes Conditions Générales de Vente (ci-après «&nbsp;CGV&nbsp;») régissent les relations
          contractuelles entre AlloRéparations (ci-après «&nbsp;le Prestataire&nbsp;») et toute personne
          physique ou morale (ci-après «&nbsp;le Client&nbsp;») recourant à ses prestations&nbsp;:
        </p>
        <ul>
          <li>Réparation de smartphones, tablettes, ordinateurs, consoles de jeu et accessoires</li>
          <li>Vente de smartphones d'occasion reconditionnés</li>
          <li>Rachat de téléphones et tablettes</li>
          <li>Vente d'accessoires (coques, chargeurs, protections d'écran, etc.)</li>
          <li>Formations à la réparation smartphone</li>
        </ul>
        <p>
          Le dépôt d'un appareil ou la passation d'une commande implique l'acceptation pleine et entière
          des présentes CGV par le Client.
        </p>
      </section>

      <section data-testid="section-devis">
        <h2>2. Devis et acceptation</h2>
        <p>
          Tout devis est <strong>gratuit et sans engagement</strong>. Il est établi sur la base des
          informations communiquées par le Client et de l'examen visuel de l'appareil. Le devis précise&nbsp;:
        </p>
        <ul>
          <li>La nature et l'étendue de la prestation</li>
          <li>Le prix TTC des pièces et de la main d'œuvre</li>
          <li>La qualité des pièces utilisées (origine constructeur ou compatibles qualité A+)</li>
          <li>Le délai estimé d'exécution</li>
          <li>La durée de validité du devis (15 jours sauf mention contraire)</li>
        </ul>
        <p>
          L'acceptation du devis vaut commande ferme et autorise le Prestataire à procéder à la réparation.
          Toute prestation supplémentaire identifiée en cours d'intervention fera l'objet d'un nouvel accord
          du Client avant exécution.
        </p>
      </section>

      <section data-testid="section-prix">
        <h2>3. Prix et modalités de paiement</h2>
        <p>
          Les prix sont indiqués en euros, toutes taxes comprises (TTC). Le paiement s'effectue
          intégralement à la restitution de l'appareil ou à la livraison du produit, par&nbsp;:
        </p>
        <ul>
          <li>Espèces (dans la limite légale en vigueur)</li>
          <li>Carte bancaire (Visa, Mastercard, sans contact)</li>
          <li>Virement bancaire (sur demande)</li>
        </ul>
        <p>
          Aucun escompte n'est accordé en cas de paiement anticipé. En cas de retrait tardif d'un appareil
          réparé (au-delà de 90 jours après notification), le Prestataire se réserve le droit d'appliquer
          des frais de stockage ou de considérer l'appareil comme abandonné conformément à la
          réglementation en vigueur.
        </p>
      </section>

      <section data-testid="section-delais">
        <h2>4. Délais d'exécution</h2>
        <p>
          Les délais annoncés sont donnés à titre indicatif. Une réparation classique est généralement
          réalisée en 30 minutes à 1 heure pour les pannes courantes (écran, batterie). Les interventions
          complexes (micro-soudure, récupération de données, commande de pièces) peuvent nécessiter
          plusieurs jours&nbsp;; le Client en est informé lors de l'établissement du devis.
        </p>
      </section>

      <section data-testid="section-garantie">
        <h2>5. Garantie sur les réparations</h2>
        <p>
          Toutes nos réparations bénéficient d'une <strong>garantie de 6 mois</strong> à compter de la
          date de restitution de l'appareil. Cette garantie couvre&nbsp;:
        </p>
        <ul>
          <li>Les pièces remplacées par le Prestataire</li>
          <li>La main d'œuvre liée à la prestation initiale</li>
          <li>Le défaut de fonctionnement directement imputable à l'intervention</li>
        </ul>
        <p>
          La garantie <strong>ne couvre pas</strong>&nbsp;:
        </p>
        <ul>
          <li>Les dommages causés par une chute, une oxydation ou un choc postérieur à la réparation</li>
          <li>Les pannes liées à une autre pièce de l'appareil non concernée par l'intervention</li>
          <li>Les dommages résultant d'une mauvaise utilisation, d'une modification ou d'une intervention par un tiers</li>
          <li>L'usure normale (batterie, port de charge, etc.)</li>
          <li>Les dégâts liés à un logiciel, virus ou mise à jour système</li>
        </ul>
        <p>
          La garantie légale de conformité (articles L.217-3 et suivants du Code de la consommation) et la
          garantie des vices cachés (articles 1641 et suivants du Code civil) restent en tout état de
          cause applicables aux ventes de produits.
        </p>
      </section>

      <section data-testid="section-occasion">
        <h2>6. Vente de smartphones d'occasion</h2>
        <p>
          Les smartphones d'occasion proposés à la vente sont reconditionnés et testés par nos soins.
          Chaque appareil est vendu&nbsp;:
        </p>
        <ul>
          <li>Avec une description précise de son état (grade A, B ou C selon l'aspect cosmétique)</li>
          <li>Avec une garantie commerciale de 6 mois minimum couvrant les défauts de fonctionnement</li>
          <li>Désimlocké et restauré aux paramètres d'usine</li>
        </ul>
        <p>
          La garantie ne couvre pas l'usure cosmétique connue et acceptée à l'achat, ni les dommages
          postérieurs à la vente (chute, oxydation, etc.).
        </p>
      </section>

      <section data-testid="section-rachat">
        <h2>7. Rachat de téléphone</h2>
        <p>
          Le prix de rachat est établi sur la base des informations communiquées par le Client (modèle,
          stockage, état). Une <strong>vérification physique</strong> de l'appareil est obligatoire avant
          paiement&nbsp;: l'estimation peut être ajustée à la hausse comme à la baisse en fonction de
          l'état réel constaté.
        </p>
        <p>
          Le Client garantit être le propriétaire légitime de l'appareil et atteste qu'il n'est ni volé,
          ni bloqué par un opérateur ou un compte iCloud / Google. Une pièce d'identité est exigée lors
          de la cession.
        </p>
      </section>

      <section data-testid="section-retractation">
        <h2>8. Droit de rétractation</h2>
        <p>
          Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation
          <strong> ne s'applique pas</strong> aux prestations de services pleinement exécutées avant la fin
          du délai de rétractation et dont l'exécution a commencé avec l'accord exprès et préalable du Client.
          La signature du devis ou le dépôt de l'appareil pour réparation valent accord exprès.
        </p>
        <p>
          Pour les ventes à distance d'accessoires ou de smartphones d'occasion, le Client dispose d'un
          délai de <strong>14 jours</strong> à compter de la réception pour exercer son droit de
          rétractation, sauf exceptions légales.
        </p>
      </section>

      <section data-testid="section-responsabilite">
        <h2>9. Limitation de responsabilité</h2>
        <p>
          Le Prestataire met tout en œuvre pour réaliser les prestations dans les règles de l'art. Il est
          tenu d'une obligation de moyens. Sa responsabilité ne pourra être engagée pour&nbsp;:
        </p>
        <ul>
          <li>La perte de données non sauvegardées préalablement par le Client (il est de la responsabilité du Client de sauvegarder ses données avant tout dépôt)</li>
          <li>L'aggravation d'un défaut préexistant non décelable lors du diagnostic initial</li>
          <li>Les conséquences indirectes (manque à gagner, préjudice commercial, etc.)</li>
          <li>L'impossibilité de réparer en cas de pièce indisponible ou de dommage trop important</li>
        </ul>
      </section>

      <section data-testid="section-donnees">
        <h2>10. Données personnelles</h2>
        <p>
          Le traitement des données personnelles du Client est régi par notre&nbsp;
          <a href="/politique-confidentialite">politique de confidentialité</a>, conforme au Règlement
          Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
        </p>
      </section>

      <section data-testid="section-litiges">
        <h2>11. Litiges et médiation</h2>
        <p>
          En cas de litige, le Client est invité à contacter en priorité le Prestataire pour rechercher
          une solution amiable. Conformément à l'article L.612-1 du Code de la consommation, le Client
          peut également recourir gratuitement à un médiateur de la consommation.
        </p>
        <p>
          À défaut de résolution amiable, les tribunaux de Montpellier seront seuls compétents,
          nonobstant pluralité de défendeurs ou appel en garantie.
        </p>
      </section>

      <section data-testid="section-modification">
        <h2>12. Modification des CGV</h2>
        <p>
          Le Prestataire se réserve le droit de modifier les présentes CGV à tout moment. Les CGV
          applicables sont celles en vigueur à la date d'acceptation du devis ou de la commande par le
          Client. La version à jour est consultable en permanence sur le site www.alloreparations.com.
        </p>
      </section>
    </LegalLayout>
  );
};

export default CGV;
